import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";
import classNames from "classnames";
import FloatingLabel from "react-bootstrap/FloatingLabel";

export default function InputTextarea({
  children,
  popoverText,
  error,
  valid,
  rows = 3,
  className,
  ...params
}) {
  return (
    <Row
      className={classNames(
        "align-items-center flex-nowrap position-relative",
        {
          "mb-3": !className,
        }
      )}
    >
      <Col xs={12} md={popoverText !== null ? 11 : 12}>
        <FloatingLabel label={params?.placeholder}>
          <Form.Control
            {...params}
            className={classNames("pe-5 pe-md-2 position-relative", {
              "border-danger": error,
              "border-success": valid,
              "pb-2 pt-4": !!params.value.length,
            })}
            as="textarea"
            rows={rows}
          />
        </FloatingLabel>
        <Col className="justify-content-end d-flex text-gray lh-lg">
          <small>
            {params.value.length}/{params.maxLength}
          </small>
        </Col>
        {children}
      </Col>

      {popoverText !== null && (
        <div
          className="position-absolute top-50 end-0 translate-middle-y w-auto me-3"
          style={{ marginTop: "-10px" }}
        >
          <PopoverBtn text={popoverText} />
        </div>
      )}
    </Row>
  );
}
